import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { useSubdomain } from 'hooks/useSubdomain';
import { Spinfinity } from 'components';

import styles from './AuthMinimalLayout.module.scss';

const AuthMinimalLayout = () => {
  const { isLoaded } = useSubdomain();

  if (!isLoaded) return null;
  return (
    <div className={styles.minimalLayout}>
      <Suspense fallback={<Spinfinity />}>
        <Outlet />
      </Suspense>
    </div>
  );
};
export default AuthMinimalLayout;
